import { Pipe, PipeTransform } from '@angular/core';

/**
 * 日付文字列成形パイプ
 * 「yyyyMMdd」から「yyyy/MM/dd」へ形式変換。
 * @export
 * @class DateStringPipe
 * @implements {PipeTransform}
 */
@Pipe({
  name: 'dateString'
})
export class DateStringPipe implements PipeTransform {

  /**
   * 日付文字列を受け取り、スラッシュ「/」を付与する。
   *
   * @param {string} date
   * @return {*}  {string}
   * @memberof DateStringPipe
   */
  transform(date: string): string {
    let formattedDate: string = '';
    if (date && date != '') {
      formattedDate = date.substr(0, 4) + '/' + date.substr(4, 2) + '/' + date.substr(6, 2);
    }
    return formattedDate;
  }
}